module.exports = __webpack_public_path__ + "media/images/step-recource---d78e234282cac0519eda4f47d4f3d7aa.jpg";